module.exports = {"pathContext":{"slug":"/it/multires/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-multires.json
// module id = 1591
// module chunks = 257927051873212